import React from "react";
import { connect } from "react-redux";
import * as subbordinateActions from './../../actions/subordinate';
import PageHeader from "./../shared/PageHeader";
import { toast } from 'react-toastify';
import SubordinateItem from "./SubordinateItem";
import {PullToRefresh} from "react-js-pull-to-refresh";
import {PullDownContent, ReleaseContent, RefreshContent} from "react-js-pull-to-refresh";
import {withRouter} from "react-router-dom";

 
class Subbordinate extends React.Component{
    componentDidMount = async () => {
        try{
            this.props.loading(true);
            await this.props.getSubordinates();
            this.props.loading(false);
        }catch(error){
            this.props.loading(false);
            if(error.response.status===400){
                this.props.history.push("/login")
            }else{
                toast.error(error.response.data.Message, {
                    position: toast.POSITION.BOTTOM_CENTER
                  });
            }
          
        }   
    }
    onRefresh = async () => {
        try{
            await this.props.getSubordinates();
        }catch(error){
            
            toast.error(error.response.data.Message, {
                position: toast.POSITION.BOTTOM_CENTER
              });
        }   
    }
    render = ()  => {
            return(
                <div className="h-100">
                    <PageHeader title="حاضرین و غایبین"/>
                    <div className="content">

                    <PullToRefresh
                      pullDownContent={<PullDownContent label="برای بارگذاری مجدد صفحه را به پایین بکشید" />}
                      releaseContent={<ReleaseContent label="برای بارگذاری رها کنید"/>}
                      refreshContent={<RefreshContent />}
                        pullDownThreshold={200}
                        onRefresh={this.onRefresh}
                        triggerHeight={50}
                        backgroundColor='white'
                        startInvisible={true}
                        
                        >
                            { this.props.subordinate.subordinates===undefined ? "" :  Object.keys(this.props.subordinate.subordinates).map((key =>{
                        return <SubordinateItem key={this.props.subordinate.subordinates[key].Id} {...this.props.subordinate.subordinates[key]}/>
                        }))}
                           
                  
                    
                  

                    </PullToRefresh>
                    </div>

                </div>
               
            );
       
           
        
    }
}
const mapToStateProps = (state) => {
    return state;
}
export default withRouter(connect(mapToStateProps,subbordinateActions)(Subbordinate));